// TODO: determine how to get the current components from the database, to here

import React, { Component } from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
/* eslint-disable */

// material ui pickers
import MomentUtils from '@date-io/moment';

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

import { withStyles } from '@material-ui/core/styles';

// icons
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import { Redirect } from "react-router-dom";

// material ui core imports
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Button,
  IconButton,
  Grid,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';

// components
import {
  RegularCard,
  ItemGrid,
  CustomInput
} from "../../components";

// icon imports, take two
import {
  Event,
  Person,
  VerifiedUser,
  Group,
  Notifications,
  CardGiftcard,
  FiberNew,
  FormatColorFill,
  Star,
  AddCircle,
  Settings,
  DonutSmall,
  Games,
  ChromeReaderMode,
  Receipt,
  LocationSearching,
  Gradient,
  Backup,
  Build,
} from "@material-ui/icons";

const rightsDefinition = {
  appearance: {
    icon: FormatColorFill,
    name: 'Appearance'
  },
  users: {
    icon: Person,
    name: 'Users'
  },
  admins: {
    icon: VerifiedUser,
    name: 'Admins'
  },
  notifications: {
    icon: Notifications,
    name: 'Notifications'
  },
  events: {
    icon: Event,
    name: 'Events'
  },
  newsletters: {
    icon: FiberNew,
    name: 'Newsletters'
  },
  sportsNews: {
    icon: DonutSmall,
    name: "Sports News",
  },
  season: {
    icon: Games,
    name: 'Sports Schedules',
  },
  friends: {
    icon: Group,
    name: 'Friends'
  },
  rewards: {
    icon: CardGiftcard,
    name: 'Rewards'
  },
  customize: {
    icon: Settings,
    name: "Customize",
  },
  lotto: {
    icon: Receipt,
    name: "Lotto",
  },
  coupons: {
    icon: ChromeReaderMode,
    name: "Coupons",
  },
  locations: {
    icon: LocationSearching,
    name: "Locations",
  },
  automation: {
    icon: Backup,
    name: "Automation",
  }
}

// reducer imports
import {
  loadUsers,
  removeFromAdmins,
  changeAdminRights,
  createNewUser
} from './reducer/actions';

// custom table cell
const CustomTableCell = withStyles(theme => ({
  head: {
    textAlign: 'center'
  },

  body: {
    fontSize: 16,
    textAlign: 'center'
  },
}))(TableCell);

// root and table styles
const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  }
});

// modal header, content, footer
const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 20px;
  border-bottom: 1px solid rgba(153, 153, 153, 0.7);
`
const ModalContent = styled.div`
  position: relative;
  padding: 0px 20px;
  overflow: hidden;
  padding-bottom: 20px;
  line-height: 50px;
`
const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid rgba(153, 153, 153, 0.7);
`

// custom modal styles - overlay and content
const customModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 102, 128, 0.5)'
  },
  content: {
    top: 'calc(50% + 30px)',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px !important',
    width: '572px'
  }
};


// Bond's the best thing to come out of England since the Mayflower!
// You can be Double-O Snake

// class declaration
class AdminList extends Component {
  // constructor, set state
  constructor (props) {
    super (props);

    this.state = {
      showModal: null,
      editingId: null,
      name: '',
      rights: {},
    }
  }

  // upon component mounting, load in all users
  componentDidMount() {
    this.props.loadUsers();
  }

  // remove administrator and reload users
  handleRemoveFromAdmins(id) {
    this.props.removeFromAdmins(id, () => this.props.loadUsers());
  }

  // hide modal upon success
  _onSuccess () {
    this.setState({ showModal: null });
  }

  // error case
  _onError (error) {
    console.log(error);
    this.setState({ showModal: null });
  }

/*
  _onCreateNewUser () {

    this.props.createNewUser({
      editingId: null,
      rights: {},

    }, this._onSuccess.bind(this), this._onError.bind(this));
  }*/

  // show the Add User modal
  showAddModal () { // TODO
    this.setState({
      newUserName: '',
      showModal: 'add'
    })
  }

  // change privileges of a user
  handleEditRights (n) { // TODO
    this.setState({
      editingId: n.id,
      rights: n.admin,
      name: n.name,
      showModal: 'edit'
    })
  }

  // apply rights to a user
  handleApplyRights() {

    let newRights = { master: this.state.rights.master || false };

    Object.keys(rightsDefinition).forEach(k => {
      if (this.state.rights[k]) {
         newRights = {...newRights, [k]: true};
      }
    });

    this.props.changeAdminRights(this.state.editingId, newRights, () => this.props.loadUsers());

    this.setState({
      editingId: null,
      name: '',
      rights: {},
      showModal: null
    });
  }

  // add an admin user
  handleAddToAdmins(id) {

    let newRights = {
      master: false,
      users: true,
    };

    this.props.changeAdminRights(id, newRights, () => this.props.loadUsers());

    this.setState({
      newUserName: '',
      showModal: null
    });
  }

  // close modal
  _onCloseModal () {
    this.setState({ showModal: null });
  }

  // show a user's rights
  renderRights(r) {
    if (r.master) {
      return  <Star />;
    }

    if (Object.keys(r).length === 0) {
      return  <AddCircle />;
    }


    return Object.keys(r)
      .filter(k => k !== 'master')
      .map(k => {
        const Icon = (rightsDefinition[k] || {}).icon;
        return Icon ? <Icon key={k}/> :<span key={k}></span>;
      });
  }

  // show the Edit modal
  renderEditModal() {
    const { rights } = this.state;

    const rightsSelector = Object.keys(rightsDefinition)
      .map(v =>
        <ItemGrid xs={6}>
          <FormControlLabel
            disabled = {rights.master}
            control={
              <Checkbox
                checked={rights[v]}
                onChange={(e, c) => {this.setState({ rights: { ...rights, [v]: c }})}}
                value={v} />
            }
            label={(rightsDefinition[v] || {}).name}
          />
        </ItemGrid>
      );

    return (
      <ReactModal isOpen={this.state.showModal === 'edit'}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={this.state.name}
        ariaHideApp={false}
        style={customModalStyles}
        >
        <ModalHeader>
          {this.state.name}
        </ModalHeader>
        <ModalContent>
          <Grid container>
            <ItemGrid xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={rights.master}
                    onChange={(e, c) => {this.setState({ rights: { ...rights, master: c }})}}
                    value="checkedMaster" />
                }
                label="Superuser rights"
              />
            </ItemGrid>
            {rightsSelector}
          </Grid>
        </ModalContent>
        <ModalFooter>
          <Button
            variant='raised'
            primary={true}
            onClick={(e) => {this.handleApplyRights()} }
          >
            Apply
          </Button>
          <Button
            variant='raised'
            style={{ marginLeft: 20 }}
            onClick={(e) => {this.setState({ showModal: false })}}
          >
            Cancel
          </Button>
        </ModalFooter>
      </ReactModal>
    );
  }

  // show the Add modal
  renderAddModal() {
    const { newUserName } = this.state;
    const candidates = (newUserName.length > 2) ? this.props.users
      .filter(u => (u.name || '').includes(newUserName) || (u.email || '').includes(newUserName))
      //.filter(u => !u.admin)
      .filter((_, i) => i < 5) : [];

    return (
      <ReactModal isOpen={this.state.showModal === 'add'}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={'New Admin'}
        ariaHideApp={false}
        style={customModalStyles}
        >
        <ModalHeader>
          Add New Admin
        </ModalHeader>
        <ModalContent>
          <Grid container>
            <ItemGrid xs={12} sm={12}>
              <CustomInput
                labelText="Search for user"
                id="newUserName"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: newUserName,
                  onChange: (evt) => {this.setState({newUserName: evt.target.value})}
                }}
              />
            </ItemGrid>
            <ItemGrid xs={12} sm={12} style={{ minHeight: '250px'}}>
              {
                candidates.map(u => (
                  <Button
                     variant='raised'
                     key={u.id}
                     fullWidth
                     primary={true}
                     onClick={(e) => {this.handleAddToAdmins(u.id)} }>
                      {u.name}
                  </Button>
                ))
            }
            </ItemGrid>
          </Grid>
        </ModalContent>
        <ModalFooter>
          <Button
            variant='raised'
            style={{ marginLeft: 20 }}
            onClick={(e) => {this.setState({ showModal: false })}}
          >
            Cancel
          </Button>
        </ModalFooter>
      </ReactModal>
    );
  }

  render() {
    // make sure only authorized Users proceed
    // check for admin rights in general
    if (!this.props.user.hasOwnProperty('admin')) {
      return (
        <Redirect from={'admins'} to={'dashboard'} key={'invalid'} />
      );
    }
    // check for rights for this page in particular
    if (!this.props.user.admin.master &&
      !this.props.user.admin.hasOwnProperty('admins'))
    {
      return (
        <Redirect from={'admins'} to={'dashboard'} key={'noTicket'} />
      );
    }

    const { classes, isLoading } = this.props;

    var users = this.props.users;
    users = users.filter((u) =>{
      if (!u.hasOwnProperty('admin')) {
        return false;
      }
      else if (u.hasOwnProperty('shard')) {
        return false;
      }
      else {
        return true;
      }
    });

    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
      <RegularCard
        cardTitle="Administrators"
        content={
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <CustomTableCell>
                  {/* Intentionally left blank */}
                </CustomTableCell>
                <CustomTableCell>
                  Name
                </CustomTableCell>
                <CustomTableCell>
                  Email
                </CustomTableCell>
                <CustomTableCell>
                  Rights
                </CustomTableCell>
                <CustomTableCell>
                  More
                </CustomTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {isLoading && <div style={{padding: 10, textAlign: 'center'}}>
                <CircularProgress /> </div>
            }
            {!isLoading && !isEmpty(users) && users
              .map(n => {
              return (
              <TableRow className={classes.row} key={n.id}>
                <CustomTableCell
                  component="th"
                  scope="row"
                  children={ <div
                    style={{
                      width: 64,
                      height: 64,
                      borderRadius: 32,
                      backgroundColor: '#ccc',
                      backgroundImage: `url("${n.profileImage}")`,
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: '50% 50%'
                    }}
                  />}
                />
                <CustomTableCell>
                  {n.name}
                </CustomTableCell>
                <CustomTableCell>
                  {n.email}
                </CustomTableCell>
                <CustomTableCell>
                  {this.renderRights(n.admin)}
                </CustomTableCell>
                <CustomTableCell>
                  <IconButton
                    tooltip="Edit user"
                    iconStyle={{ fill: 'rgb(15, 102, 128)' }}
                    onClick={(e) => this.handleEditRights(n)}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    tooltip="Delete user"
                    iconStyle={{ fill: 'rgb(15, 102, 128)' }}
                    onClick={(e) => this.handleRemoveFromAdmins(n.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </CustomTableCell>
              </TableRow>
              );
            })}
              <Button
                onClick={() => this.showAddModal()}
              >
                Add New Admin
              </Button>
            </TableBody>
            {
              this.state.showModal === 'edit' ? this.renderEditModal() :
              this.state.showModal === 'add' ? this.renderAddModal() : null
            }
          </Table>
        }
      />
      </MuiPickersUtilsProvider>
    );
  }
}

AdminList.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  users: state.userReducer.users,
  isLoading: state.userReducer.isLoading,
  user: state.authReducer.user,
  loggedIn: state.authReducer.loggedIn,
});

const mapDispatchToProps = {
  loadUsers,
  removeFromAdmins,
  changeAdminRights,
  createNewUser
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AdminList));
